"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../styles/palette");

var _Icon = _interopRequireDefault(require("../Icon"));

var _style = require("./style");

var Link = function Link(_ref) {
  var handleClick = _ref.handleClick,
      icon = _ref.icon,
      text = _ref.text,
      testId = _ref.testId;
  return _react["default"].createElement(_style.LinkStyled, {
    role: "button",
    onMouseDown: handleClick,
    tabIndex: 0,
    "data-test-id": testId
  }, icon && _react["default"].createElement(_Icon["default"], {
    icon: icon,
    size: 22,
    color: _palette.palette.link
  }), _react["default"].createElement(_style.Text, {
    icon: icon
  }, text));
};

Link.propTypes = {
  handleClick: _propTypes["default"].func.isRequired,
  icon: _propTypes["default"].string,
  text: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].string,
  testId: _propTypes["default"].string
};
Link.defaultProps = {
  icon: null,
  color: '',
  testId: undefined
};
var _default = Link;
exports["default"] = _default;